import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UpdateMutationVariables } from '../../graphql/types';
import { GraphbackOperationType, getDataObject } from '../../graphql/hooks/getDataObject';
import { cacheKeys } from '../../graphql/hooks/cacheKeys';
import { useFetcher } from '../../graphql/hooks/useFetcher';

export const useUpdateIssue = () => {
  const queryClient = useQueryClient();
  const fetcherFn = useFetcher(UPDATE_ISSUE);

  return useMutation({
    mutationFn: async (variables: UpdateMutationVariables) => {
      const data = await fetcherFn(variables);
      return getDataObject(data, 'issue', GraphbackOperationType.update);
    },
    onSuccess: async () => {
      // Invalidate all issue-related queries including list queries
      await queryClient.invalidateQueries({ 
        queryKey: cacheKeys('issue').all,
        exact: false 
      });
    },
  });
};

const UPDATE_ISSUE = `
  mutation UpdateIssue($input: MutateIssueInput!) {
    updateIssue(input: $input) {
      id
      title
      severity
      isPinned
    }
  }
`;
